import { appInsights, withoutSearchParams } from './appInsights';
import { AccountInfo } from '@azure/msal-browser';

// Set user context when authenticated
export const setUserContext = (account: AccountInfo | null): void => {
  if (account) {
    appInsights.setAuthenticatedUserContext(
      account.localAccountId,
      account.username,
      true
    );
  }
};

// Track page initialization
export const trackPageInit = (pageId: string, pageType: string, pageTitle: string): void => {
  appInsights.trackPageView({
    name: pageTitle,
    uri: withoutSearchParams(window.location.href),
    properties: {
      page_id: pageId,
      page_type: pageType,
      page_title: pageTitle
    }
  });
};

// Track component interactions
export const trackComponentInteraction = (
  componentName: string,
  componentTitle: string,
  componentType: string,
  interactionType: string,
  interactionValue: string,
  interactionUrl?: string
): void => {
  const payload = {
    name: 'component_interaction',
    properties: {
      component_name: componentName,
      component_title: componentTitle,
      component_type: componentType,
      interaction_type: interactionType,
      interaction_value: interactionValue,
      interaction_url: withoutSearchParams(interactionUrl || window.location.href)
    }
  };
  console.log('AppInsights trackEvent payload:', payload);
  appInsights.trackEvent(payload);
};
